import React, { useContext, useState } from 'react';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import ToastNotification from 'components/common/Toast';
import { LocaleContext } from 'routes/Router';
import { login } from 'routes/AppUrls';
import CheckValidation from 'utils/Validation';
import ReusableButton from 'components/common/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { forgotPasswordCallAPI } from 'store/forgotPassword/action';
import 'assets/styles/common.scss';
import AuthLayout from 'components/common/AuthLayout';
import Ptext from 'components/common/Ptext';
import loginHero from 'assets/images/login/loginHero.png';
import LoginLogo from 'assets/images/login/LogoAlt.svg';
import 'assets/styles/auth.scss';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const [conf, setConf] = ToastNotification();
  const [isError, setIsError] = useState(false);
  const { locale } = useContext(LocaleContext);
  const forgotPasswordLoader = useSelector(
    (state) => state?.forgotPasswordReducer?.loading
  );

  const [formValue, setformValue] = useState({
    email: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setformValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    const error = CheckValidation(formValue);
    setIsError(error);
    if (error.submit) {
      let body = {
        email: formValue?.email?.toLowerCase(),
      };
      dispatch(
        forgotPasswordCallAPI(body, {
          run: true,
          handleFunction: (res) => handleRedirect(res),
          handleToastError: (res) => ToastErrorFunction(res),
          navigate: navigate,
          toast: true,
        })
      );
    }
  };

  const ToastErrorFunction = (res) => {
    setConf({
      msg: intl.formatMessage({ id: 'Invalid Credential!' }),
      variant: 'error',
    });
  };

  const handleRedirect = (res) => {
    if (res?.data?.status_code === 200) {
      setConf({
        msg: intl.formatMessage({ id: 'login successfully!' }),
        variant: 'success',
      });
      navigate(login(locale));
    } else {
      setConf({
        msg: intl.formatMessage({
          id: 'Invalid credentials.Please try again.',
        }),
        variant: 'error',
      });
    }
  };

  return (
    <AuthLayout
      heroImage={loginHero}
      logo={LoginLogo}
      quote="Allue transformed our salon by doubling our monthly bookings and completely eliminating no-shows"
      author="Alisa Lisa"
    >
      <div className="login-content">
        <Ptext variant="title" className="welcome-title">
          <FormattedMessage id="Forgot Password?" />
        </Ptext>

        <Ptext variant="body" className="welcome-subtitle mt-2">
          <FormattedMessage id="Enter your registered email to receive password reset instructions." />
        </Ptext>

        {/* EMAIL */}
        <div className="mt-4">
          <LabelWithInput
            label={<FormattedMessage id="E-mail Address" />}
            placeholder={intl.formatMessage({
              id: 'E-mail Address',
            })}
            name="email"
            type="text"
            value={formValue?.email}
            onChange={handleInputChange}
            errorText={
              isError && isError.email?.error && isError.email?.errorMessage
            }
          />
        </div>

        {/* BACK TO LOGIN */}
        <div className="forgot-wrapper">
          <Ptext
            variant="body"
            className="forgot-password font-medium"
            onClick={() => navigate(login(locale))}
          >
            <FormattedMessage id="Back to Login" />
          </Ptext>
        </div>

        {/* BUTTON */}
        <div className="mt-4">
          <ReusableButton
            fullWidth
            variant="contained"
            color="#FFFFFF"
            fontSize="16px"
            fontWeight="500"
            padding="14px"
            bgColor="#000000"
            borderRadius="999px"
            fontFamily="Poppins, sans-serif"
            loading={forgotPasswordLoader}
            onClick={handleSubmit}
          >
            <FormattedMessage id="Submit" />
          </ReusableButton>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
